import { useState, useEffect, useMemo } from 'react';
import { Row, Col, Card, CardBody, CardHeader, Table, Collapse, Button, Spinner, FormGroup, Label, Input } from 'reactstrap';
import './Biosecurity.css';
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import SpinnerContainer from '../Utilities/Ui/SpinnerContainer';
import { FaChevronUp, FaChevronDown, FaChevronRight, FaChevronLeft, FaTrash, FaPlus } from 'react-icons/fa';
import uuid from 'react-uuid';
import MapView from '../Map/MapView';
import ToggleSwitch from '../ThreeStateToggle/ToggleSwitch';
import { useNavigate } from "react-router-dom";
import Documents from '../Uploads/Documents';
import { ToastContainer, toast as toastytoast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Tooltip as ReactTooltip } from "react-tooltip";
import Select, { components, ValueContainerProps } from 'react-select';
import { convertToRaw, EditorState, convertFromHTML, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "draft-js/dist/Draft.css";
import draftToHtml from "draftjs-to-html";
import { apiGet, apiPost } from "../Utilities/Hooks/apiWrapper";

const Option = (props) => {
    return (
        <div>
            <components.Option {...props}>
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null}
                />{" "}
                <label>{props.label}</label>
            </components.Option>
        </div>
    );
};

const Biosecurity = ({ handleWizardChanged, handleWizardChangedBack, handleMoveToNextPage }) => {
    const isAddEditItem = localStorage.getItem("isAddEditItem");
    const roleName = localStorage.getItem("roleName"); const [isNextButtonVisible, setIsNextButtonVisible] = useState(false);
    const [show_HistoricalActions, setShow_HistoricalActions] = useState(false);
    const [show_SectionComment, setShow_SectionComment] = useState(false);
    const saveRightsForNonItemFieldsAndTables = localStorage.getItem("saveRightsForNonItemFieldsAndTables"); const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));
    const [farmId, setFarmId] = useState(localStorage.getItem("defaultFarmId")); const [toggleSwitch, setToggleSwitch] = useState('map & details');
    const [loading, setLoading] = useState(true);
    const [itemList, setItemList] = useState([]);
    const [biosecurity, setBiosecurity] = useState({ outlineList: [], itemList: [], SectionName: 'Biosecurity', Section: 'Biosecurity', isWizardCompleted: false, sectionObj: {}, sectionComment: '' });
    const [mapDetails, setMapDetails] = useState({
        isOutlinePage: false, isLMUPage: false, isCenterReq: false, isFarmCenterEditable: false, isFarmOutlineEditable: false, zoomLevel: 15,
        polyType: '', itemsEditable: false, highlighteditemId: 0, isClear: false
    });
    const [largeEnterpriseDetails, setLargeEnterpriseDetails] = useState({ isLargeEnterprise: false, LMUList: [], selectedLMUId: 0 })
    const [isOpen, setIsOpen] = useState(false); const [isIconUp, setIsIconUp] = useState(false);
    const [isOpen1, setIsOpen1] = useState(false); const [isIconUp1, setIsIconUp1] = useState(false);
    const toggle = () => {
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
    };
    const toggle1 = () => {
        setIsOpen1(!isOpen1)
        setIsIconUp1(!isIconUp1)
    };
    const handleSectionCommentChange = (e) => {
        const { name, value, checked, type } = e.target;
        setBiosecurity({ ...biosecurity, sectionComment: value })
    }
    const navigate = useNavigate();
    const [editorState, setEditorState] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const OnPageload = async (e) => {
        try {
            const response = await apiGet(
                '/api/biosecurity/GetBiosecurity/', {
                params: {
                    farmId: farmId
                }
            }
            );
            if (response.data.section != null) {
                var section = window.wizardDetails.filter(x => x.controllerName == response.data.section.routePath);
                if (section.length > 0) {
                    setIsNextButtonVisible(section[0].isSectionCompleted);
                }
            }
            setBiosecurity({
                ...biosecurity, outlineList: response.data.outlineList, itemList: [], isWizardCompleted: response.data.isFWFPCompleted, sectionObj: response.data.section, sectionComment: response.data.sectionComment
            });
            setShow_HistoricalActions(response.data.show_HistoricalActions);
            setShow_SectionComment(response.data.show_SectionComment);
            setBiosecurityRisksAndVectorRows(response.data.biosecurityRisksAndVectorItems);
            setBiosecurityRiskManagementRows(response.data.biosecurityRiskManagementItems);
            setMapDetails({ ...mapDetails, zoomLevel: response.data.selectedZoomlevel, polyType: '' });
            setLargeEnterpriseDetails({ ...largeEnterpriseDetails, isLargeEnterprise: response.data.islargeEnterprise, LMUList: response.data.lmuItemList })
            const content = ContentState.createFromBlockArray(convertFromHTML(response.data.sectionComment == null ? '' : response.data.sectionComment))
            setEditorState(EditorState.createWithContent(content));
            setLoading(false);
        } catch (err) {
            console.log(err);
        }
    }

    const handleItemHighlight = (itemId) => {
        setMapDetails({ ...mapDetails, highlighteditemId: itemId })
    }

    const mapView = useMemo(() => {
        return (
            <MapView width={toggleSwitch == 'map' ? '95vw' : '50vw'}
                height={toggleSwitch == 'map' ? '95vw' : '50vw'}
                itemModel={biosecurity}
                mapDetails={mapDetails}
                largeEnterpriseDetails={largeEnterpriseDetails}>
            </MapView>
        )
    }, [biosecurity, mapDetails, largeEnterpriseDetails, toggleSwitch])

    useEffect(() => {
        setLoading(true);
        OnPageload();
    }, [])

    const toggleSwitchChange = (e) => {
        setToggleSwitch(e)
        if (e == 'map') {
            document.getElementById('mapView').style.display = 'block';
            document.getElementById('nonMapView').style.display = 'none';
        }
        else if (e == 'details') {
            document.getElementById('mapView').style.display = 'none';
            document.getElementById('nonMapView').style.display = 'block';
            document.getElementById('nonMapView').style.width = '50vw';
        }
        else {
            document.getElementById('mapView').style.display = 'block';
            document.getElementById('nonMapView').style.display = 'block';
            document.getElementById('nonMapView').style.width = '50vw';
        }
    }
    const handlePageChange = async (section, method) => {
        await SaveSectionComment();
        if (method == 'handleWizardChanged') {
            handleWizardChanged(section);
        }
        else if (method == 'handleMoveToNextPage') {
            handleMoveToNextPage(section);
        }
        else if (method == 'handleWizardChangedBack') {
            handleWizardChangedBack(section);
        }
    }
    const saveSectionComment = async () => {
        setSavingSectionComment(true);
        try {
            var form = {
                farmId: farmId,
                comment: draftToHtml(convertToRaw(editorState.getCurrentContent()))//infrastructure.sectionComment
            };
            const response = await apiPost(
                '/api/biosecurity/SaveSectionComment/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            if (response) {
                setSavingSectionComment(false);
            }
        } catch (err) {
            console.log(err);
            setSavingSectionComment(false);
        }
    }
    const SaveSectionComment = async () => {
        try {
            var form = {
                farmId: farmId,
                comment: draftToHtml(convertToRaw(editorState.getCurrentContent()))
            };
            const response = await apiPost(
                '/api/biosecurity/SaveSectionComment/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });

        } catch (err) {
            console.log(err);
        }
    }

    const [savingSectionComment, setSavingSectionComment] = useState('');

    const [biosecurityRisksAndVectorRows, setBiosecurityRisksAndVectorRows] = useState([]);
    const [biosecurityRiskManagementRows, setBiosecurityRiskManagementRows] = useState([]);
    const handleRiskNameChange = idx => e => {
        const tempRows = [...biosecurityRisksAndVectorRows];
        tempRows[idx].riskName = e.target.value;
        setBiosecurityRisksAndVectorRows(tempRows);
    };
    const handleTitleChange = idx => e => {
        const tempRows = [...biosecurityRiskManagementRows];
        tempRows[idx].title = e.target.value;
        setBiosecurityRiskManagementRows(tempRows);
    };
    const handleDescriptionChange = idx => e => {
        const tempRows = [...biosecurityRiskManagementRows];
        tempRows[idx].description = e.target.value;
        setBiosecurityRiskManagementRows(tempRows);
    };
    const handleAssociatedwithChange = idx => e => {
        const tempRows = [...biosecurityRiskManagementRows];
        tempRows[idx].associatedwith = e;
        setBiosecurityRiskManagementRows(tempRows);
    };
    const handleRiskDescriptionChange = idx => e => {
        const tempRows = [...biosecurityRisksAndVectorRows];
        tempRows[idx].riskDescription = e.target.value;
        setBiosecurityRisksAndVectorRows(tempRows);
    };
    const handleRiskAssociatedwithChange = idx => e => {
        const tempRows = [...biosecurityRisksAndVectorRows];
        tempRows[idx].riskAssociatedwith = e;
        setBiosecurityRisksAndVectorRows(tempRows);
    };
    const handleBiosecurityRisksAndVectorRowsRemoveSpecificRow = (idx) => () => {
        const tempRows = [...biosecurityRisksAndVectorRows]
        tempRows.splice(idx, 1)
        setBiosecurityRisksAndVectorRows(tempRows);
    }
    const handleBiosecurityRiskManagementRowsRemoveSpecificRow = (idx) => () => {
        const tempRows = [...biosecurityRiskManagementRows]
        tempRows.splice(idx, 1)
        setBiosecurityRiskManagementRows(tempRows);
    }
    const [savingBiosecurityRisksAndVectors, setSavingBiosecurityRisksAndVectors] = useState('');
    const handleBiosecurityRisksAndVectorRowsSubmit = async (e) => {
        e.preventDefault()
        setSavingBiosecurityRisksAndVectors(true);
        let tempContactRows = [...biosecurityRisksAndVectorRows];
        let form = {
            FarmId: farmId,
            BiosecurityRisksAndVectors: [],
            UserId: userId
        }
        for (var i = 0; i < tempContactRows.length; i++) {
            var obj = {};
            obj.Id = tempContactRows[i].id;
            obj.FarmId = farmId;
            obj.RiskName = tempContactRows[i].riskName;
            obj.RiskDescription = tempContactRows[i].riskDescription;
            obj.RiskAssociatedwith = tempContactRows[i].riskAssociatedwith;
            form.BiosecurityRisksAndVectors.push(obj);
        }
        const response = await apiPost(
            '/api/biosecurity/SaveBiosecurityRisksAndVectors/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
        if (response.data != null) {
            if (response.data.status) {
                toast.success("Biosecurity Risks And Vectors Saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                setSavingBiosecurityRisksAndVectors(false);
                setBiosecurityRisksAndVectorRows(response.data.content);
            }
        }
    };
    const [savingBiosecurityRiskManagement, setSavingBiosecurityRiskManagement] = useState('');
    const handleBiosecurityRiskManagementRowsSubmit = async (e) => {
        e.preventDefault()
        setSavingBiosecurityRiskManagement(true);
        let tempContactRows = [...biosecurityRiskManagementRows];
        let form = {
            FarmId: farmId,
            BiosecurityRiskManagement: [],
            UserId: userId
        }
        for (var i = 0; i < tempContactRows.length; i++) {
            var obj = {};
            obj.Id = tempContactRows[i].id;
            obj.FarmId = farmId;
            obj.Title = tempContactRows[i].title;
            obj.Description = tempContactRows[i].description;
            obj.Associatedwith = tempContactRows[i].associatedwith;
            form.BiosecurityRiskManagement.push(obj);
        }
        const response = await apiPost(
            '/api/biosecurity/SaveBiosecurityRiskManagement/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
        if (response.data != null) {
            if (response.data.status) {
                toast.success("Biosecurity Risk Management Saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                setSavingBiosecurityRiskManagement(false);
                setBiosecurityRiskManagementRows(response.data.content);
            }
        }
    };
    const handleBiosecurityRisksAndVectorRowsAddRow = () => {
        const item = {
            id: 0, riskName: '', riskDescription: '', riskAssociatedwith:[]
        };
        setBiosecurityRisksAndVectorRows([...biosecurityRisksAndVectorRows, item]);
    };
    const handleBiosecurityRiskManagementRowsAddRow = () => {
        const item = {
            id: 0, title: '', description: '', associatedwith: ''
        };
        setBiosecurityRiskManagementRows([...biosecurityRiskManagementRows, item]);
    };
    var associatedwithList = [];
    var obj = {};
    obj.label = 'Pests'; obj.value = 'Pests';
    associatedwithList.push(obj);
    var obj1 = {};
    obj1.label = 'Weeds'; obj1.value = 'Weeds';
    associatedwithList.push(obj1);
    var obj2 = {};
    obj2.label = 'Diseases'; obj2.value = 'Diseases';
    associatedwithList.push(obj2);
    return (
        <div>
            <ToastContainer position="top-center" containerStyle={{ top: '50%' }} />
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Row>
                <Col><h3 className="header3">{biosecurity.SectionName}</h3></Col>
                {biosecurity.isWizardCompleted != true && !loading &&
                    <Col>
                        {(roleName == 'SWNZ Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                            <>
                                <Button className="float-end btn-next-page" onClick={(section) => handlePageChange(biosecurity.Section, 'handleWizardChanged')}>Next <FaChevronRight /> </Button>
                            </>
                        }
                        {roleName != 'SWNZ Admin' && saveRightsForNonItemFieldsAndTables == 'false' && isNextButtonVisible &&
                            <>
                                <Button className="float-end btn-next-page" onClick={(section) => handlePageChange(biosecurity.Section, 'handleMoveToNextPage')}>Next <FaChevronRight /> </Button>
                            </>
                        }
                        <Button className="float-end btn-next-page" onClick={(section) => handlePageChange(biosecurity.Section, 'handleWizardChangedBack')}>Back <FaChevronLeft /> </Button>
                    </Col>
                }
            </Row>
            {
                loading ? <SpinnerContainer /> :
                    <div>
                        <Row style={{ marginTop: '10px' }}>
                            <Col id='mapView'>
                                <Row className="map-layer" style={{ marginTop: '10px' }}>
                                    <Col>
                                        <Row>
                                            <Col sm="3"> {toggleSwitch == 'map & details' &&
                                                <Button size="sm" id="btnShowFullmap" style={{ backgroundColor: "#41533d" }} className="btn" onClick={(e) => toggleSwitchChange('map')}>Full Map&nbsp;&nbsp;
                                                    <img src="/images/button-details_expand.png" className="card_icon" ></img>
                                                </Button>
                                            }
                                                {toggleSwitch == 'map' &&
                                                    <Button size="sm" id="btnShowFullmap" style={{ backgroundColor: "#41533d" }} className="btn" onClick={(e) => toggleSwitchChange('map & details')}>Small Map&nbsp;&nbsp;
                                                        <img src="/images/button-details_contract.png" style={{}} className="card_icon" ></img>
                                                    </Button>
                                                }
                                            </Col>
                                        </Row>
                                        {mapView}
                                    </Col>
                                </Row>
                            </Col>
                            <Col id='nonMapView' style={{ width: "50vw", display: toggleSwitch == 'map' ? 'none' : 'block', }}>
                                <Row style={{ marginTop: '10px' }}>
                                    <Col sm="3">
                                        {toggleSwitch == 'map & details' &&
                                            <Button size="sm" id="btnShowFulldetails" style={{ backgroundColor: "#41533d" }} className="btn" onClick={(e) => toggleSwitchChange('details')}>Full Details&nbsp;&nbsp;
                                                <img src="/images/button-details_expand.png" style={{}} className="card_icon" ></img>
                                            </Button>
                                        }
                                        {toggleSwitch == 'details' &&
                                            <Button size="sm" id="btnShowFulldetails" style={{ backgroundColor: "#41533d" }} className="btn" onClick={(e) => toggleSwitchChange('map & details')}>Small Details&nbsp;&nbsp;
                                                <img src="/images/button-details_contract.png" style={{}} className="card_icon" ></img>
                                            </Button>
                                        }
                                    </Col>
                                </Row>
                                {show_SectionComment &&
                                    <>
                                    <Row style={{ marginTop: "0.5vh" }}>
                                        <Col sm="12">
                                            <FormGroup>
                                                <Label for="sectionComment" className="text-capitalize" style={{ fontSize: "16px" }}><b>Section Comment</b> <span className="text-lowercase">(add any information around the features, actions, or risks, that have been considered on this page)</span></Label>
                                                <Editor handlePastedText={() => false}
                                                    defaultEditorState={editorState}
                                                    onEditorStateChange={setEditorState}
                                                    wrapperClassName="wrapper-class"
                                                    editorClassName="editor-class"
                                                    toolbarClassName="toolbar-class"
                                                    toolbar={
                                                        {
                                                            options: ['inline'], inline: {
                                                                inDropdown: false,
                                                                options: ['bold', 'italic', 'underline'],
                                                            }
                                                        }
                                                    }
                                                />
                                            </FormGroup>

                                        </Col>
                                        <Col sm="12">
                                            {savingSectionComment ?
                                                <Button style={{ float: "right" }} onClick={saveSectionComment} color="success" disabled>
                                                    <Row>
                                                        <Col sm="8">
                                                            <span>
                                                                {' '}Saving
                                                            </span>
                                                        </Col>
                                                        <Col sm="4">
                                                            <Spinner size="sm">
                                                                Saving...
                                                            </Spinner>
                                                        </Col>
                                                    </Row>
                                                </Button>
                                                :
                                                <Button style={{ float: "right" }} onClick={saveSectionComment} color="success" size="sm">
                                                    Save
                                                </Button>
                                            }
                                        </Col>
                                    </Row>
                                    <br />
                                    </>    
                                }
                                
                                <Row >
                                    <Col>
                                        <Card className="cardNonLeftRadius">
                                            <CardHeader className="header" onClick={toggle}>
                                                <Row>
                                                    <Col sm="11"><span className="text-uppercase fw-bold color-dark-teal">Key Biosecurity Risks and Risk Vectors
                                                        </span>
                                                    </Col>
                                                    <Col sm="1" className="toggleoutline_lt">{isIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                                                </Row>
                                            </CardHeader>
                                            <Collapse isOpen={isOpen}>
                                                <CardBody>
                                                    <Row>
                                                        <Col>
                                                            <span><b>Identify risks based on occurrence likelihood and business impact. Include animals, people, vehicles, machinery, and external feed.</b>
                                                            </span>
                                                        </Col>
                                                    </Row>
                                                    <br />
                                                    <Row>
                                                        <Col>
                                                            {(roleName == 'SWNZ Admin' || isAddEditItem == 'true') &&
                                                                <>
                                                                    <button style={{ float:"right" }} onClick={handleBiosecurityRisksAndVectorRowsAddRow} type="button" id="btnUpdate" className="btn btn-sm btn-pluse">
                                                                        <FaPlus />
                                                                    </button>
                                                                </>
                                                            }
                                                        </Col>
                                                    </Row>
                                                    <br />
                                                    <Row>
                                                        <Col sm="12">
                                                            <table style={{ float: "right", marginTop: "-10px" }} className="table table-bordered table-hover" id="tab_logic">
                                                                <thead>
                                                                    <tr>
                                                                        <th className="text-left"> Risk Name </th>
                                                                        <th className="text-left"> Risk Description </th>
                                                                        <th className="text-left"> Associated with </th>
                                                                        <th />
                                                                    </tr>
                                                                </thead>
                                                                <tbody className="text-left">
                                                                    {biosecurityRisksAndVectorRows.map((item, idx) => (
                                                                        <tr id="addr0" key={idx}>
                                                                            <td style={{ display: "none" }}>{biosecurityRisksAndVectorRows[idx].id}</td>
                                                                            <td style={{ width: "10%" }}>
                                                                                <input
                                                                                    type="text"
                                                                                    name="riskName"
                                                                                    value={biosecurityRisksAndVectorRows[idx].riskName}
                                                                                    onChange={handleRiskNameChange(idx)}
                                                                                    className="form-control"
                                                                                />
                                                                            </td>
                                                                            <td style={{ width: "10%" }}>
                                                                                <textarea
                                                                                    type="text"
                                                                                    name="riskDescription"
                                                                                    value={biosecurityRisksAndVectorRows[idx].riskDescription}
                                                                                    onChange={handleRiskDescriptionChange(idx)}
                                                                                    className="form-control"
                                                                                />
                                                                            </td>
                                                                            <td style={{ width: "10%" }}>
                                                                                {/*<Input type="select" value={biosecurityRisksAndVectorRows[idx].riskAssociatedwith} onChange={handleRiskAssociatedwithChange(idx)} name="riskAssociatedwith" id="riskAssociatedwith">*/}
                                                                                {/*    <option key={uuid()} value="Select">Select</option>*/}
                                                                                {/*    <option key={uuid()} value="Pests">Pests</option>*/}
                                                                                {/*    <option key={uuid()} value="Weeds">Weeds</option>*/}
                                                                                {/*    <option key={uuid()} value="Diseases">Diseases</option>*/}
                                                                                {/*</Input>*/}
                                                                                <Select
                                                                                    id="riskAssociatedwith"
                                                                                    name="riskAssociatedwith"
                                                                                    closeMenuOnSelect={false}
                                                                                    className="dropdown"
                                                                                    placeholder="Select"
                                                                                    defaultValue={biosecurityRisksAndVectorRows[idx].riskAssociatedwith}
                                                                                    options={associatedwithList}
                                                                                    onChange={handleRiskAssociatedwithChange(idx)}
                                                                                    isClearable={false} isMulti hideSelectedOptions={false}
                                                                                    components={{
                                                                                        Option
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                            <td style={{ width: "5%" }}>
                                                                                {(roleName == 'SWNZ Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                                                                                    <>
                                                                                    <button style={{ float: "right" }} onClick={handleBiosecurityRisksAndVectorRowsRemoveSpecificRow(idx)} type="button" id="btnUpdate" className="btn btn-sm btn-danger">
                                                                                            <FaTrash />
                                                                                        </button>
                                                                                    </>
                                                                                }
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            {(roleName == 'SWNZ Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                                                                <>
                                                                {savingBiosecurityRisksAndVectors ?
                                                                    <Button style={{ float: "right" }} onClick={handleBiosecurityRisksAndVectorRowsSubmit}
                                                                            color="success"
                                                                            disabled
                                                                        >
                                                                            <Row>
                                                                                <Col sm="6">
                                                                                    <span>
                                                                                        {' '}Saving
                                                                                    </span>
                                                                                </Col>
                                                                                <Col sm="6">
                                                                                    <Spinner size="sm">
                                                                                        Saving...
                                                                                    </Spinner>
                                                                                </Col>
                                                                            </Row>
                                                                        </Button>
                                                                        :
                                                                    <Button style={{ float: "right" }} onClick={handleBiosecurityRisksAndVectorRowsSubmit} color="success" size="sm">
                                                                            Save
                                                                        </Button>
                                                                    }
                                                                </>
                                                            }
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Collapse>
                                        </Card>
                                    </Col>
                                </Row>
                                <br />
                                <Row >
                                    <Col>
                                        <Card className="cardNonLeftRadius">
                                            <CardHeader className="header" onClick={toggle1}>
                                                <Row>
                                                    <Col sm="11"><span className="text-uppercase fw-bold color-dark-teal">Processes for Risk Management or minimisation
                                                    </span>
                                                    </Col>
                                                    <Col sm="1" className="toggleoutline_lt">{isIconUp1 ? <FaChevronUp /> : <FaChevronDown />}</Col>
                                                </Row>
                                            </CardHeader>
                                            <Collapse isOpen={isOpen1}>
                                                <CardBody>
                                                    <Row>
                                                        <Col>
                                                            <span><b>Identify how the introduced risks are managed or minimised</b>
                                                            </span>
                                                        </Col>
                                                    </Row>
                                                    <br />
                                                    <Row>
                                                        <Col>
                                                            {(roleName == 'SWNZ Admin' || isAddEditItem == 'true') &&
                                                                <>
                                                                <button style={{ float: "right" }} onClick={handleBiosecurityRiskManagementRowsAddRow} type="button" id="btnUpdate" className="btn btn-sm btn-pluse">
                                                                        <FaPlus />
                                                                    </button>
                                                                </>
                                                            }
                                                        </Col>
                                                    </Row>
                                                    <br />
                                                    <Row>
                                                        <Col sm="12">
                                                            <table style={{ float: "right", marginTop: "-10px" }} className="table table-bordered table-hover" id="tab_logic">
                                                                <thead>
                                                                    <tr>
                                                                        <th className="text-left"> Title </th>
                                                                        <th className="text-left"> Description </th>
                                                                        <th className="text-left"> Associated with </th>
                                                                        <th />
                                                                    </tr>
                                                                </thead>
                                                                <tbody className="text-left">
                                                                    {biosecurityRiskManagementRows.map((item, idx) => (
                                                                        <tr id="addr0" key={idx}>
                                                                            <td style={{ display: "none" }}>{biosecurityRiskManagementRows[idx].id}</td>
                                                                            <td style={{ width: "10%" }}>
                                                                                <input
                                                                                    type="text"
                                                                                    name="title"
                                                                                    value={biosecurityRiskManagementRows[idx].title}
                                                                                    onChange={handleTitleChange(idx)}
                                                                                    className="form-control"
                                                                                />
                                                                            </td>
                                                                            <td style={{ width: "10%" }}>
                                                                                <textarea
                                                                                    type="text"
                                                                                    name="description"
                                                                                    value={biosecurityRiskManagementRows[idx].description}
                                                                                    onChange={handleDescriptionChange(idx)}
                                                                                    className="form-control"
                                                                                />
                                                                            </td>
                                                                            <td style={{ width: "10%" }}>
                                                                                <Select
                                                                                    id="associatedwith"
                                                                                    name="associatedwith"
                                                                                    closeMenuOnSelect={false}
                                                                                    className="dropdown"
                                                                                    placeholder="Select"
                                                                                    defaultValue={biosecurityRiskManagementRows[idx].associatedwith}
                                                                                    options={associatedwithList}
                                                                                    onChange={handleAssociatedwithChange(idx)}
                                                                                    isClearable={false} isMulti hideSelectedOptions={false}
                                                                                    components={{
                                                                                        Option
                                                                                    }}
                                                                                />
                                                                                {/*<Input type="select" value={biosecurityRiskManagementRows[idx].associatedwith} onChange={handleAssociatedwithChange(idx)} name="associatedwith" id="associatedwith">*/}
                                                                                {/*    <option key={uuid()} value="Select">Select</option>*/}
                                                                                {/*    <option key={uuid()} value="Pests">Pests</option>*/}
                                                                                {/*    <option key={uuid()} value="Weeds">Weeds</option>*/}
                                                                                {/*    <option key={uuid()} value="Diseases">Diseases</option>*/}
                                                                                {/*</Input>*/}
                                                                            </td>
                                                                            <td style={{ width: "5%" }}>
                                                                                {(roleName == 'SWNZ Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                                                                                    <>
                                                                                        <button style={{ float: "right" }} onClick={handleBiosecurityRiskManagementRowsRemoveSpecificRow(idx)} type="button" id="btnUpdate" className="btn btn-sm btn-danger">
                                                                                            <FaTrash />
                                                                                        </button>
                                                                                    </>
                                                                                }
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            {(roleName == 'SWNZ Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                                                                <>
                                                                {savingBiosecurityRiskManagement ?
                                                                    <Button style={{ float: "right" }} onClick={handleBiosecurityRiskManagementRowsSubmit}
                                                                            color="success"
                                                                            disabled
                                                                        >
                                                                            <Row>
                                                                                <Col sm="6">
                                                                                    <span>
                                                                                        {' '}Saving
                                                                                    </span>
                                                                                </Col>
                                                                                <Col sm="6">
                                                                                    <Spinner size="sm">
                                                                                        Saving...
                                                                                    </Spinner>
                                                                                </Col>
                                                                            </Row>
                                                                        </Button>
                                                                        :
                                                                    <Button style={{ float: "right" }} onClick={handleBiosecurityRiskManagementRowsSubmit} color="success" size="sm">
                                                                            Save
                                                                        </Button>
                                                                    }
                                                                </>
                                                            }
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Collapse>
                                        </Card>
                                    </Col>
                                </Row>
                                <br />
                                <Row>
                                    <Col>
                                        {
                                            biosecurity.sectionObj.isDocumentUploadReq && <Documents refid={biosecurity.sectionObj.id} uploadType="Section" open={false} showArrow={true}></Documents>
                                        }
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
            }
        </div>
    )
}
export default Biosecurity;